import React from 'react';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import Icon from '../Icons';
import './styles.css';

const CookieSettings = () => {
  const { openManagement } = useCookieConsent();

  return (
    <button 
      className="cookie-settings-btn"
      onClick={openManagement}
      title="Manage Cookie Preferences"
    >
      <Icon name="cookie" size={16} />
      Cookie Settings
    </button>
  );
};

export default CookieSettings;
